import React, { useState } from "react";
import "../assets/css/style.css";

// MarqueeCard as a named export
export const MarqueeCard = ({ testimonial }) => {
  const StarRating = ({ rating }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="d-flex mb-2">
        {[...Array(fullStars)].map((_, i) => (
          <i
            key={`full-${i}`}
            className="bi bi-star-fill text-warning me-1"
          ></i>
        ))}
        {hasHalfStar && <i className="bi bi-star-half text-warning me-1"></i>}
        {[...Array(emptyStars)].map((_, i) => (
          <i key={`empty-${i}`} className="bi bi-star text-warning me-1"></i>
        ))}
      </div>
    );
  };

  return (
    <div
      className="card shadow-sm flex-shrink-0 border-0 bg-light"
      style={{ width: "350px", height: "250px" }}
    >
      <div className="card-body p-4 d-flex flex-column">
        <StarRating rating={testimonial.rating} />
        <div className="mb-3 flex-grow-1">
          <i className="bi bi-quote fs-1 text-muted opacity-25"></i>
          <p className="fst-italic fs-6 text-start">{testimonial.content}</p>
        </div>
        <div className="d-flex align-items-center">
          <div className="me-3">
            {testimonial.avatar ? (
              <img
                src={testimonial.avatar}
                alt={testimonial.name}
                className="rounded-circle"
                style={{ width: "50px", height: "50px", objectFit: "cover" }}
              />
            ) : (
              <div
                className="rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white"
                style={{ width: "50px", height: "50px" }}
              >
                {testimonial.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </div>
            )}
          </div>
          <div className="text-start">
            <h6 className="mb-0 fw-bold">{testimonial.name}</h6>
            <small className="text-muted">{testimonial.role}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

// TestimonialMarquee as default export
const TestimonialMarquee = ({
  testimonials = [
    {
      name: "Rajesh Deshmukh",
      role: "Office Manager, Mumbai",
      content:
        "RR Facility Management has transformed our office maintenance in Nariman Point. Their professional staff maintains our workplace impeccably.",
      rating: 5,
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      name: "Priya Patil",
      role: "HR Head, Pune",
      content:
        "The cleaning staff from RR Facility Management at our Hinjewadi IT park facility is exceptional. They understand corporate cleanliness standards perfectly.",
      rating: 4.5,
      avatar: "https://randomuser.me/api/portraits/women/45.jpg",
    },
    {
      name: "Vikram Joshi",
      role: "Facility Head, Thane",
      content:
        "Best facility management service in Thane. Their 24/7 support team has resolved all our maintenance issues at our residential complex promptly.",
      rating: 5,
      avatar: "https://randomuser.me/api/portraits/men/44.jpg",
    },
    {
      name: "Ananya Chavan",
      role: "Property Manager, Navi Mumbai",
      content:
        "RRFM's services have made maintaining our commercial complex in Vashi effortless. Their team is reliable and hardworking.",
      rating: 4,
      avatar: "https://randomuser.me/api/portraits/women/63.jpg",
    },
    {
      name: "Arjun Pawar",
      role: "CEO, Nagpur",
      content:
        "As a growing company in Nagpur, we needed a facility partner who could scale with us. RRFM has exceeded our expectations in every aspect.",
      rating: 5,
    },
    {
      name: "Sanjay More",
      role: "Hospital Administrator, Nashik",
      content:
        "RRFM's healthcare facility management services at our Nashik hospital are outstanding. Their sanitization protocols are top-notch.",
      rating: 5,
      avatar: "https://randomuser.me/api/portraits/men/55.jpg",
    },
    {
      name: "Meera Kolte",
      role: "School Principal, Aurangabad",
      content:
        "Our school campus in Aurangabad has never been cleaner. RRFM's staff is punctual and thorough in their work.",
      rating: 4.5,
    },
  ],
  direction = "left",
  speed = 30,
  pauseOnHover = true,
  gap = "24px",
  className = "",
}) => {
  const [isPaused, setIsPaused] = useState(false);
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  const animationStyle = {
    animation: `marquee ${speed}s linear infinite`,
    animationDirection: direction === "left" ? "normal" : "reverse",
    animationPlayState: isPaused ? "paused" : "running",
  };

  return (
    <div
      className={`testimonial-marquee position-relative overflow-hidden ${className}`}
      style={{ height: "320px" }}
      onMouseEnter={() => pauseOnHover && setIsPaused(true)}
      onMouseLeave={() => pauseOnHover && setIsPaused(false)}
    >
      <div
        className="position-absolute start-0 h-100 w-25 z-1"
        style={{
          background:
            "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
        }}
      ></div>
      <div
        className="position-absolute end-0 h-100 w-25 z-1"
        style={{
          background:
            "linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
        }}
      ></div>

      <div
        className="d-flex flex-nowrap h-100 align-items-center"
        style={{
          ...animationStyle,
          gap: gap,
          width: "fit-content",
        }}
      >
        {duplicatedTestimonials.map((testimonial, index) => (
          <MarqueeCard key={index} testimonial={testimonial} />
        ))}
      </div>
    </div>
  );
};

export default TestimonialMarquee;
